import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import substanceThcInvolvementItemValidator from './validators/item';
import { SubstanceThcInvolvementModel } from './types';

const substanceThcInvolvementsValidator: ValidateJSModel<SubstanceThcInvolvementModel> = {
  Involved: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.Involved && attributes?.Involved.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: substanceThcInvolvementItemValidator,
        },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceThcInvolvementsValidator;
